import React from "react";

export interface TooltipIconListItem {
  id: string;
  icon: string;
  tooltip: string;
  onClick?: () => void;
  dataName?: string;
}

interface TooltipIconListProps {
  items?: TooltipIconListItem[];
  listClassName?: string;
  itemClassName?: string;
}

const baseListClasses =
  "list-none text-[2rem] mb-0 mt-0 text-right flex flex-wrap gap-2.5 justify-end";
const baseItemClasses =
  "inline-flex items-center justify-center mr-1 md:mr-1 mb-0 font-body cursor-pointer hover:opacity-80 transition-opacity";

const TooltipIconList: React.FC<TooltipIconListProps> = ({
  items = [],
  listClassName = "",
  itemClassName = "",
}) => {
  if (!items.length) return null;

  return (
    <ul className={[baseListClasses, listClassName].filter(Boolean).join(" ")}>
      {items.map((item) => (
        <li
          key={item.id}
          title={item.tooltip}
          className={[
            baseItemClasses,
            itemClassName,
            item.onClick ? "cursor-pointer" : "",
          ]
            .filter(Boolean)
            .join(" ")}
          data-name={item.dataName}
          onClick={item.onClick}
          aria-label={item.tooltip}
          role={item.onClick ? "button" : undefined}
        >
          <span className="iconify" data-icon={item.icon} data-inline="false" />
        </li>
      ))}
    </ul>
  );
};

export default TooltipIconList;
